import React, { useEffect, useState } from "react";

import Drawer from "../../components/ui/Drawer";
import "./file-upload.scss";
import WalletService, { fetchLoadLimit } from "../../api/wallet-service";
import { WALLET_API_URL } from "../../api/urlMetaData";
import { useSelector } from "react-redux";

import Table, { Data, Row } from "../../components/ui/table/table";

import { useQuery } from "@tanstack/react-query";
import { formatAmount, getAmountWithCurrency } from "../../utils/utils";
import { useLocale } from "../../hooks/useLocale";

const LoadLimitDrawer = ({ title, onClose }) => {
  const currentUser = useSelector((s) => s.auth.currentUser);
  const { localize } = useLocale(["cards"]);

  const limitQuery = useQuery(["cards/limit-load"], () =>
    fetchLoadLimit({
      userHashId: currentUser.userHashId,
      clientHashId: currentUser.clientHashId,
      userType: currentUser.productType,
    })
  );

  return (
    <>
      <Drawer title={title} onClose={onClose} width={500}>
        <>
          <Table
            loading={limitQuery.isLoading}
            cols={localize("limit.table.cols", { returnObjects: true })}
            dataSize={limitQuery.data?.body.length}
          >
            <>
              {limitQuery.data?.body.map((item, index) => {
                return (
                  <>
                    <Row>
                      <Data>{index + 1}</Data>
                      <Data>
                        {item.transactionType === "CardLoad" ? (
                          <span>CARD LOAD</span>
                        ) : (
                          <span>VENDOR PAYMENT</span>
                        )}
                      </Data>
                      <Data>
                        {getAmountWithCurrency(
                          formatAmount(item.perTransactionLimit),
                          item.currencyCode
                        )}
                      </Data>
                    </Row>
                  </>
                );
              })}
            </>
            {/* show empty list */}
          </Table>
        </>
      </Drawer>
    </>
  );
};

export default LoadLimitDrawer;
